import React from 'react';
import './RouteLoader.scss';
import thriweMark from '../../assets/images/logo-sm.png';
import thriweWordmark from '../../assets/custom/Thriwe_name_logo.png';

// Suspense fallback for lazily-loaded routes.
//
// variant="fullscreen" (default) covers the viewport — used for the very first
// paint, when no layout exists yet.
// variant="content" fills only the layout's content area, so the header and
// sidebar stay mounted and visible while a route chunk downloads.
const RouteLoader = ({ variant = 'fullscreen' }) => {
  return (
    <div className={`route-loader route-loader--${variant}`} role="status" aria-live="polite" aria-busy="true">
      <div className="route-loader__brand">
        {/* The mark is radially symmetric, so spinning it doubles as the spinner. */}
        <span className="route-loader__halo" aria-hidden="true" />
        <img src={thriweMark} alt="" className="route-loader__mark" />
      </div>

      {variant === 'fullscreen' && <img src={thriweWordmark} alt="Thriwe" className="route-loader__wordmark" />}

      <span className="route-loader__bar" aria-hidden="true">
        <span className="route-loader__bar-fill" />
      </span>

      <span className="visually-hidden">Loading…</span>
    </div>
  );
};

export default RouteLoader;
